query TravelerModalDropdownsData {
  countries(orderBy: COUNTRY_ASC) {
    nodes {
      id
      country
    }
  }
  companyDepartments(
    orderBy: [NAME_ASC, PRIMARY_KEY_ASC]
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
      _isTaSelectable
    }
  }
  userOccupationTitles(orderBy: USER_OCCUPATION_TITLE_ASC) {
    nodes {
      id
      userOccupationTitle
    }
  }
  travelPolicies(orderBy: [SORT_ORDER_ASC, DESCRIPTION_ASC]) {
    nodes {
      id
      description
      isContractual
      isCompanion
      isEconomyClassAllowed
      isBusinessClassAllowed
      isFirstClassAllowed
      isPremiumClassAllowed
      isCharterClassAllowed
      companionTickets
      companionAmount
      isDefaultCustomizable
      companyCurrency {
        isoCode
      }
      travelPolicyAllowancesByTravelPolicyId(
        orderBy: TRAVEL_POLICY_EXPENDITURE_TYPE_BY_EXPENDITURE_TYPE_ID__SORT_ORDER_ASC
      ) {
        nodes {
          id
          expenditureType {
            expenditureType
          }
          _allowanceDescription
          isAllowanceCustomizable
          policyAllowance
          policyMaxLimit
        }
      }
    }
  }
  travelerCompanionMasters(
    orderBy: [COMPANY_OR_LAST_NAME_ASC, FIRST_NAME_ASC]
  ) {
    nodes {
      id
      _fullName
      travelerDepartmentId
      isEconomyClassPreferred
      isBusinessClassPreferred
      isFirstClassPreferred
      isPremiumClassPreferred
      isCharterClassPreferred
    }
  }
  dietaryRequirements(orderBy: [SORT_ORDER_ASC, ID_ASC]) {
    nodes {
      id
      isDescriptionRequired
      description
    }
  }
}
